<template>
  <div id="star-get">
    <ul>
      <li>
        <div class="unit">选择额度：</div>
        <div class="unit-info unit-info-bg" :class="{'unit-action': unitSelect===1}" @click="clickHandler(1)">
          <img src="@/assets/images/star_img.png" alt="star_img"/>
          <span class="unit-cont">1个</span>
          <span class="money"> ¥2</span>
        </div>
        <div class="unit-info unit-info-bg" :class="{'unit-action': unitSelect===2}" @click="clickHandler(2)">
          <img src="@/assets/images/star_img.png" alt="star_img"/>
          <span class="unit-cont">10个</span>
          <span class="money"> ¥10</span>
        </div>
        <div class="unit-info unit-info-bg" :class="{'unit-action': unitSelect===3}" @click="clickHandler(3)">
          <img src="@/assets/images/star_img.png" alt="star_img"/>
          <span class="unit-cont">100个</span>
          <span class="money"> ¥79</span>
        </div>
      </li>
      <li>
        <div class="unit">输入数量：</div>
        <div class="unit-info">
          <input class="num-input" type="number" v-model="starNumber" />
          <span class="num-unit">个</span>
        </div>
      </li>
      <li>
        <div class="unit">支付方式：</div>
        <div class="unit-info unit-info-bg" :class="{'unit-action':payAction == 1}" @click = "payClickHandler(1)">
          <img class="star-pay" src="@/assets/images/star_wx.png" alt="star_wx"/>
          <span class="num-pay">使用微信支付</span>
        </div>
        <div class="unit-info unit-info-bg" :class="{'unit-action':payAction == 2}" @click = "payClickHandler(2)">
          <img class="star-pay" src="@/assets/images/star_zfb.png" alt="star_zfb"/>
          <span class="num-pay">支付宝支付</span>
        </div>
      </li>
      <li>
        <div class="unit">实付款：</div>
        <div class="unit-info">
          <span class="money"> ¥{{starNumber*unitNumber}}</span>
        </div>
        <div class="star-info-btn">立即支付</div>
      </li>
    </ul>
    <div class="qrcode-pay">
      <img src="@/assets/images/star_wx.png" alt="" width="100px">
      <span>付款二维码</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StarGet",
  components: {
  },
  data () {
    return {
      starNumber: 10,
      unitSelect: 1,
      payAction: 1,
      unitNumber: 2
    }
  },
  methods: {
    clickHandler (index) {
      this.unitSelect = index;
      switch(index){
        case 1: this.unitNumber = 2; breack;
        case 2: this.unitNumber = 10; breack;
        case 3: this.unitNumber = 79; breack;
        default: break;
      }

    },
    payClickHandler (index) {
      this.payAction = index;
    }
  }
};
</script>

<style lang="scss" scoped>
#star-get{
  ul{
    margin: 10px 30px;
    li{
      display: flex;
      height: 50px;
      line-height: 50px;
      .unit{
        font-size: 16px;
        color: #595959;
      }
      .unit-action{
        background-color: #C4C4C4;
      }
      .unit-info-bg{
        cursor: pointer;
        &:hover{
          background-color: #C4C4C4;
        }
      }
      .unit-info{
        margin: 0 20px;
        margin-top: 10px;
        display: flex;
        height: 33px;
        border-radius: 20px;
        padding: 0 10px;
        
        img{
          width: 21px;
          height: 21px;
          margin-top: 6px;
        }
        .star-pay{
          margin: 6px 10px 0 0;
        }
        .unit-cont{
          font-size: 12px;
          color: #595959;
          margin: 0 6px;
        }
        .money{
          font-size: 20px;
          color: #E9A400;
          line-height: 33px;
        }
        .num-input{
          width: 89px;
          height: 27px;
          border: 1px solid rgba(190,190,190,1);
          border-radius: 16px;
          padding: 0 10px;
          outline: none;
          color: #E9A400;
          margin: 0 10px 0 0;
        }
        .num-unit{
          line-height: 33px;
        }
        .num-pay{
          line-height: 33px;
        }
      }
      .star-info-btn{
        width: 100px;
        height: 36px;
        line-height: 36px;
        color: #fff;
        border-radius: 20px;
        text-align: center;
        font-size: 16px;
        background-color: #F1B934;
        margin-top: 6px;
        cursor: pointer;
        &:hover{
          background-color: #e44b19;
        }
      }
    }
  }
  .qrcode-pay{
    margin: 0 30px;
  }
}
</style>

